import { setLocale } from "yup";
import * as nl from "../yup/nl";

export const handleLanguageChange = (lng: string) => {
  if (lng === "nl") {
    setLocale(nl);
  }
  setLocale({});
};
